export const LOGIN_COOKIE_KEY = 'login-cookie'
export const DEFAULT_LOCALE = 'default'
export const SUPER_ADMIN_ROLE = 'SUPER_ADMIN'
export const ADMIN_ROLE = 'ADMIN'
export const USER_ROLE = 'USER'

// Getters
export const GET_SESSION_TOKEN = 'getSessionToken'
export const GET_NESTED_CREATION_STACK_TOP = 'getNestedCreationStackTop'
export const GET_CONTENT_DASHBOARD_DATA_TABLE_PAGINATION_STATE = 'getContentDashboardDataTablePaginationState'
export const GET_MEDIA_DASHBOARD_DATA_TABLE_PAGINATION_STATE = 'getMediaDashboardDataTablePaginationState'
export const GET_LOCALE_DISPLAY_NAME = 'getLocaleDisplayName'
export const GET_CONTENT_TYPE_IDENTIFIER_TO_CONTENT_TYPE_HASH = 'getContentTypeIdentifierToContentTypeHash'
export const GET_CONTENT_DASHBOARD_DEFAULT_TABLE_CONFIG = 'getContentDashboardDefaultTableConfig'
export const GET_FILTERED_ENTRIES = 'getFilteredEntries'
export const GET_FILTERED_MEDIA_ENTRIES = 'getFilteredMediaEntries'
export const GET_FILTERED_ENTRIES_REFERENCE_FIELD_CHOOSE_EXISTING = 'getFilteredEntriesReferenceFieldChooseExisting'
export const GET_FILTERED_ENTRIES_REORDER_CONTENT = 'getFilteredEntriesReorderContent'
export const GET_SPACE_PROPERTY_UI_DASHBOARD_CONTENT_SORT_MAP = 'setPropertiesModuleUIDashboardContentSortMap'

//Mutations
export const INIT_SESSION_TOKEN = 'initSessionToken'
export const SET_SESSION_TOKEN = 'setSessionToken'
export const SET_SPACE_METADATA = 'setSpaceMetadata'
export const SET_CURRENT_USER = 'setCurrentUser'
export const SET_SPACE_CONTENT_TYPES = 'setSpaceContentTypes'
export const SET_SPACE_LOCALIZATIONS = 'setSpaceLocalizations'
export const SET_CURRENT_LOCALE = 'setCurrentLocale'
export const SET_CONTENT_DASHBOARD_STATE = 'setContentDashboardState'
export const SET_REFERENCE_FIELD_CONTENT_TYPE = 'setReferenceFieldContentType'
export const SET_REFERENCE_FIELD_CHOOSE_EXISTING_FILTER_TERM = 'setReferenceFieldChooseExistingFilterTerm'
export const PUSH_REFERENCE_FILTER_ENTRIES = 'pushReferenceFilterEntries'
export const SPLICE_REFERENCE_FILTER_ENTRIES = 'spliceReferenceFilterEntries'
export const CLEAR_REFERENCE_FILTER_ENTRIES = 'clearReferenceFilterEntries'
export const PUSH_REFERENCE_FIELD_CHOOSE_EXISTING_FILTER_ENTRIES = 'pushReferenceFieldChooseExistingFilterEntries'
export const SPLICE_REFERENCE_FIELD_CHOOSE_EXISTING_FILTER_ENTRIES = 'spliceReferenceFieldChooseExistingFilterEntries'
export const CLEAR_REFERENCE_FIELD_CHOOSE_EXISTING_FILTER_ENTRIES = 'clearReferenceFieldChooseExistingFilterEntries'
export const PUSH_REORDER_CONTENT_FILTER_ENTRIES = 'pushReorderContentFilterEntries'
export const SPLICE_REORDER_CONTENT_FILTER_ENTRIES = 'spliceReorderContentFilterEntries'
export const CLEAR_REORDER_CONTENT_FILTER_ENTRIES = 'clearReorderContentFilterEntries'
export const SET_LOAD_PROPERTIES_STATE = 'setLoadPropertiesState'
export const SET_PROPERTIES_MODULE_UI_DASHBOARD_CONTENT_DEFAULT = 'setPropertiesModuleInitialSelectedContentTypeOnDashboardIdentifier'
export const SET_PROPERTIES_MODULE_UI_DASHBOARD_CONTENT_SORT_MAP = 'setPropertiesModuleUIDashboardContentSortMap'

export const SET_CONTENT_DASHBOARD_DATA_TABLE_PAGINATION_STATE = 'setContentDashboardDataTablePaginationState'
export const SET_MEDIA_DASHBOARD_DATA_TABLE_PAGINATION_STATE = 'setMediaDashboardDataTablePaginationState'
export const SET_SPACE_CONTENT = 'setSpaceContent'
export const UNSET_SPACE_CONTENT = 'unSetSpaceContent'
export const SET_SPACE_CONTENT_ARCHIVED = 'setSpaceContentArchived'
export const UNSET_SPACE_CONTENT_ARCHIVED = 'unSetSpaceContentArchived'
export const PUSH_NESTED_CREATION_OBJECT = 'pushNestedCreationObject'
export const SET_REFERENCE_NESTED_CREATION_OBJECT_STACK_TOP = 'setReferenceNestedCreationStackTop'
export const REMOVE_NESTED_CREATION_STACK_TOP = 'getNestedCreationStackTop'
export const RESET_NESTED_CREATION_STACK = 'resetNestedCreationStack'
export const SET_REORDER_CONTENT_BACKING_ARRAY = 'setReorderContentBackingArray'
export const SET_REORDER_CONTENT_BACKING_ARRAY_AND_SORT = 'setReorderContentBackingArrayAndSort'
export const SET_REORDER_CONTENT_FILTER_TERM = 'setReorderContentFilterTerm'
export const SET_REORDER_CONTENT_IDENTIFIER = 'setReorderContentIdentifier'

export const SET_SPACE_ASSET_CONTENT_TYPE = 'setSpaceAssetContentTypes'
export const SET_MEDIA_DASHBOARD_STATE = 'setMediaDashboardState'
export const SET_TRIM_ASSET_STATE = 'setTrimAssetState'
export const SET_ARCHIVE_ASSET_STATE = 'setArchiveAssetState'
export const SET_CREATE_ASSET_STATE = 'setCreateAssetState'
export const SET_CREATE_ASSET_PROGRESS = 'setCreateAssetProgress'
export const SET_STITCH_ASSETS_STATE = 'setStitchAssetsState'

export const SET_ENTRIES = 'setEntries'
export const SET_EXPORT_USERS_URL_STATE = 'setExportUsersUrlState'

// Actions
export const LOAD_SPACE_METADATA = 'loadSpaceMetadata'
export const LOAD_CURRENT_USER = 'loadCurrentUser'
export const LOAD_SPACE_CONTENT_TYPES = 'loadSpaceContentTypes'
export const LOAD_SPACE_LOCALIZATIONS = 'loadSpaceLocalizations'
export const LOAD_SPACE_PROPERTIES = 'loadSpaceProperties'
export const LOAD_SPACE_PROPERTY_UI_DASHBOARD_CONTENT_DEFAULT = 'loadSpacePropertyUIDashboardContentDefault'
export const LOAD_SPACE_PROPERTY_UI_DASHBOARD_CONTENT_SORT_MAP = 'loadSpacePropertyUIDashboardContentSortMap'
export const LOAD_SPACE_ASSET_CONTENT_TYPE = 'loadSpaceAssetContentTypes'
export const A_TRIM_ASSET = 'actionTrimAsset'
export const A_ARCHIVE_ASSET = 'actionArchiveAsset'
export const A_CREATE_ASSET = 'actionCreateAsset'
export const A_STITCH_ASSETS = 'actionStitchAssets'
export const LOAD_SPACE_CONTENT = 'loadSpaceContent'
export const LOAD_SPACE_CONTENT_ARCHIVED = 'loadSpaceContentArchived'
export const UPDATE_ENTRY = 'updateEntry'
export const UPDATE_ARRAY_OF_ENTRIES = 'updateArrayOfEntries'
export const SET_CONTENT_DASHBOARD_STATE_AND_RELOAD = 'setContentDashboardStateAndReload'
export const A_SET_CONTENT_DASHBOARD_TABLE_CONFIG_FROM_SPACE_PROPERTY = 'actionSetContentDashboardTableConfigFromSpaceProperty'
export const LOAD_SPACE_ASSET_CONTENT = 'loadSpaceAssetContent'
export const PURGE_SPACE_STATE_FOR_LOGOUT = 'purgeStateForLogout'
export const LOAD_EXPORT_USERS_URL = 'loadExportUsersUrl'

export const SET_MEDIA_DASHBOARD_STATE_AND_RELOAD = 'setMediaDashboardStateAndReload'

// Loading States
export const LOADING_PRISTINE = 0
export const LOADING_STARTED = 1
export const LOADING_COMPLETED_SUCCESS = 2
export const LOADING_COMPLETED_FAILURE = 3

export const AUTH_HEADER_TOKEN = 'Authorization'
export const DRAFT_TEXT = 'draft'
export const PUBLISHED_TEXT = 'published'
export const ARCHIVED_TEXT = 'archived'

// Custom events

export const EVENT_INPUT = 'sfr:input'
export const EVENT_VALIDATION_STATE = 'sfr:validation-state'
export const EVENT_TOUCHED = 'sfr:touched'
export const EVENT_NESTED_CREATION = 'sfr:nested-creation'
export const EVENT_FILE_SELECTED = 'sfr:file-selected'

// Validation names
export const VALIDATION_CATEGORY = 'category'
export const VALIDATION_ENUM = 'enum'

// Entry field types
export const TYPE_TEXT_SHORT = 'text_short'
export const TYPE_TEXT_LONG = 'text_long'
export const TYPE_BOOLEAN = 'boolean'
export const TYPE_NUMBER = 'number'
export const TYPE_DATETIME = 'datetime'
export const TYPE_LOCATION = 'location'
export const TYPE_REFERENCE = 'reference'
export const CONTENT_TYPE_ASSET = 'asset'


// Reference filter modes
export const MODE_REFERENCE_FILTER_DEFAULT = 0
export const MODE_REFERENCE_FILTER_CHOOSE_EXISTING = 1
export const MODE_REFERENCE_FILTER_REORDER = 2

// Snackbar colors
export const SNACKBAR_COLOR_SUCCESS = 'success'
export const SNACKBAR_COLOR_ERROR = 'error'
export const SNACKBAR_COLOR_INFO = 'info'

// route names
export const R_NAME_EDIT_MEDIA = 'spaceDashboardEditMedia'
export const R_NAME_ADD_MEDIA = 'spaceDashboardAddMedia'
export const R_NAME_ADD_ENTRY = 'spaceDashboardAddEntry'
export const R_NAME_EDIT_ENTRY = 'spaceDashboardEditEntry'
export const R_NAME_EDIT_ENTRY_LOCALE = 'spaceDashboardEditEntryLocale'

// asset categories
export const ASSET_CATEGORY_IMAGE = 'Image'
export const ASSET_CATEGORY_AUDIO = 'Audio'
export const ASSET_CATEGORY_PDF = 'PDF'
export const ASSET_CATEGORY_VIDEO = 'Video'

export const SPACE_PROPERTY_UI_DASHBOARD_CONTENT_DEFAULT = 'ui.dashboard.content.default'
export const SPACE_PROPERTY_UI_DASHBOARD_CONTENT_SORT = 'ui.dashboard.content.sort'

export const SORT_DIRECTION_ASCENDING = 'ASC'
export const SORT_DIRECTION_DESCENDING = 'DESC'



